import BaseAPI from "./base/base-api";

class UserSettingAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "UserSetting";

  /**
   * Cập nhật
   */
  set(data) {
    let request = {
      url: this.getAPIUrl(),
      data: data,
    };

    return this.postAsync(request);
  }
}

export default new UserSettingAPI();
